import { FetchStatusInitialStatus } from '../constants/fetch_status';
import { RTKQueryState } from '../types/redux';
export var getFetchStatusString = function (statusForPortalAction, portalAction) {
    var _a;
    return (((_a = statusForPortalAction === null || statusForPortalAction === void 0 ? void 0 : statusForPortalAction[portalAction]) === null || _a === void 0 ? void 0 : _a.status) ||
        FetchStatusInitialStatus.INITIAL_FETCH_STATUS);
};
export var isFetchPending = function (statusForPortalAction, portalAction) {
    var fetchStatusString = getFetchStatusString(statusForPortalAction, portalAction);
    return (fetchStatusString === FetchStatusInitialStatus.INITIAL_FETCH_STATUS ||
        fetchStatusString === RTKQueryState.PENDING);
};
export var isFetchFulfilled = function (statusForPortalAction, portalAction) {
    var fetchStatusString = getFetchStatusString(statusForPortalAction, portalAction);
    return fetchStatusString === RTKQueryState.FULFILLED;
};
export var isFetchRejected = function (statusForPortalAction, portalAction) {
    var fetchStatusString = getFetchStatusString(statusForPortalAction, portalAction);
    return fetchStatusString === RTKQueryState.REJECTED;
};
